<template>
	<div 
	class="z-select-box"
	:class="[size ? 'z-select-box-' + size : '', {
      'is-disableds': disabled
    }]"
	@mouseenter.native="selecto = true"
	@mouseleave="selecto = false">
<input class="z-select-input" :style="'width:'+ (size - 10) +'px'" type="text" :placeholder="placeholder" :disabled="disabled" readonly="readonly" :value="value.name" />
<a class="z-select-open" @click='!disabled ? selecto = !selecto : ""'><i class="z-select-down" :class="{'z-select-down-top':!selecto}"></i></a>
<div class="z-select-option" v-show="selecto" :class="[ size ? 'z-select-box-' + size : '', tag == 'page' ? 'select-paga' : '' ]">
	<a v-if="zoptions.length == 0">没有数据</a>
	<template v-if="zoptions.length != 0">
		<a :key="index" class="list" v-for="(p,index) in zoptions" @click.stop="optionClik(p)">{{ p.name }}</a>
		</template>
		</div>
		</div>
</template>
<script>
export default {
  name: "zSelect",
  props: {
    size: String,
    placeholder: String,
    disabled: Boolean,
    zoptions: {
      type: [Array, Object, String, Number],
      default: ""
    },
    value: [Array, Object, String, Number],
    tag: {
      type: [String],
      default: ""
    }
  },
  data: function() {
    return {
      selecto: false,
      selectdata: ""
    };
  },
  watch: {
    value(val) {
      this.selectdata = val.name;
    }
  },
  methods: {
    optionClik: function(data) {
      data.is = true;
      this.$emit("input", data);
      this.selectdata = data.name;
      this.selecto = false;
      this.$emit("change", data);
    }
  }
};
</script>
<style>
.z-select-box {
  border: solid 1px #e5e5e5;
  color: #333;
  position: relative;
  cursor: pointer;
  width: 200px;
  font-size: 12px;
  border-radius: 2px;
  background-color: #fff;
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  height: 32px;
}
.z-select-open {
  display: inline-block;
  border-left: solid 1px #e5e5e5;
  position: absolute;
  right: 0;
  top: 0;
  width: 32px;
  height: 32px;
}
.z-select-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #999;
  position: absolute;
  right: 11px;
  top: 15px;
  transition: transform 0.3s;
  transform: translateY(-50%) rotate(180deg);
}

.z-select-down-top {
  transform: translateY(-50%);
}
.z-select-input {
  display: inline-block;
  padding-left: 10px;
  width: 150px;
  line-height: 30px;
  height: 30px;
  cursor: text;
  overflow: hidden;
  outline: none;
  border: none;
  background-color: #fff;
}
.is-disableds,
.is-disableds:hover,
.is-disableds:focus {
  background-color: #eef1f6;
  border-color: #d1dbe5;
  color: #bbb;
  cursor: not-allowed;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.is-disableds .z-select-input {
  background-color: #eef1f6;
  border-color: #d1dbe5;
  color: #bbb;
}
.z-select-option {
  width: 200px;
  border: solid 1px #e5e5e5;
  z-index: 2;
  overflow-y: auto;
  max-height: 180px;
  position: absolute;
  left: -1px;
  top: 32px;
}
.select-paga {
  top: -106px;
}
.z-select-option a {
  display: block;
  height: 26px;
  line-height: 26px;
  text-align: left;
  padding: 0 10px;
  background: #fff;
  position: relative;
}
.z-select-option a:hover {
  background: #ccc;
}

.z-select-option .list .child-box {
  display: none;
}
.z-select-option .list:hover .child-box {
  display: block;
}
.z-select-option .list .child-box {
  position: absolute;
  top: 0;
  left: 160px;
  width: 165px;
  border: solid 1px #e5e5e5;
  z-index: 2;
  overflow: hidden;
  overflow-y: auto;
  max-height: 180px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
}
.z-select-option .list .child {
  height: 26px;
  line-height: 26px;
  text-align: left;
  padding: 0 10px;
  width: 100%;
  background: #fff;
}
.z-select-option .list .child:hover {
  background: #eee;
}
.overflowinitial {
  overflow-y: initial;
  visibility: visible;
  max-height: 300px;
}
.z-select-child-s {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 6px solid #999;
  position: absolute;
  right: 11px;
  top: 15px;
  transition: transform 0.3s;
  transform: translateY(-50%) rotate(180deg);
}
.z-select-option .z-select-brand {
  background-color: #fff;
  margin: 0;
}
.z-select-option .z-select-brand li {
  display: inline-block;
  padding: 3px 5px;
  margin: 2px 2px;
}
.z-select-option .z-select-brand .on {
  background-color: #ccc;
}
.z-select-box-100 {
  width: 102px;
}
.z-select-box-120 {
  width: 122px;
}
.z-select-box-280 {
  width: 280px;
}
.z-select-box-630 {
  width: 630px;
}
.z-select-box-320 {
  width: 320px;
}
.z-select-box-480 {
  width: 480px;
}
</style>